// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/style/main.css";

import Vue from "vue";
import App from "./App";
import router from "./router";

import Vant from "vant";
import { Toast } from "vant";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "vant/lib/index.css";
import lib from "../static/main.js";
import lang_ from "./js/locales.js";
// 实时改变根元素字体大小
require("./js/setRem.js");
import myfn from "./js/util.js";
import http from "./js/http.js";
// import 'vue-googlemaps/dist/vue-googlemaps.css'
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(Vant);
Vue.use(ElementUI);

Vue.use(VueGoogleMaps, {
  load: {
    //填入申请的apiKey账号
    // key: 'AIzaSyDbyHAWtGu9bJzlqORuYwke4WcwfsztvEU',
    key: "AIzaSyCujUc1iFYa8GBWthpm3IOJp6_rxcBjI-I", // 沒有配置限制 本地測試用
    libraries: "places",
    language:
      window.localStorage.getItem("foodStoryLanguage") == "hk" ? "zh_HK" : "en",
  },
});

router.beforeEach((to, from, next) => {
  //判斷 新老鏈接
  let brandId = myfn.getBrandStaticId(to.params);
  if (to.name == "noServer") {
    next();
  } else if (!to.params || !to.params.arg) {
    next(`/login/${myfn.setQueryParams(brandId, 1)}`);
  } else {
    var notLogRouteName = [
      "register",
      "login",
      "get_password",
      "update_password",
      "test",
      "information",
      "share",
    ]; // 不判斷是否登錄
    if (notLogRouteName.indexOf(to.name) == -1) {
      var type = to.params.type;
      if (to.name == "login" && type.indexOf("true")) {
        return;
      }
      let userinfo = localStorage.getItem(`userinfo_${brandId}`);
      if (!userinfo) {
        Toast({
          duration: 2000,
          message: lang_.t("Identity expired"),
          onClose: () => {
            next(`/login/${myfn.setQueryParams(brandId, 1)}`);
          },
        });
        return;
      }
    }
    next();
  }
});

router.tab = function (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};
Vue.prototype.lib = lib;

window.regExpPhone = new RegExp("^[0-9]\\d{7,10}$");
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  beforeCreate() {
    myfn.setArea();
  },
  created() {
    let ww = window.innerWidth;
    if (myfn.IsPC()) {
      if (ww > 375) {
      }
    }
    if (!localStorage.randomWord) {
      localStorage.randomWord = myfn.randomWord(true, 24, 48);
    }
    http.setHeaders();
  },
  mounted() {},
  methods: {},
  components: {
    App,
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js